import { render } from "./CButtonAdd.vue?vue&type=template&id=3d601bea&scoped=true"
const script = {}

import "./CButtonAdd.vue?vue&type=style&index=0&id=3d601bea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d601bea"]])

export default __exports__